export default function AccessRequestActions({
  status,
  loading = false,
  disabled = false,
  onAccept,
  onReject,
  onRevoke,
}) {
  const normalizedStatus = String(status || "pending").toLowerCase();

  if (normalizedStatus === "pending" && !disabled) {
    return (
      <div
        className="navbar__notif-actions"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="navbar__notif-btn navbar__notif-btn--accept"
          disabled={loading}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onAccept?.();
          }}
        >
          {loading ? "..." : "Accept"}
        </button>
        <button
          type="button"
          className="navbar__notif-btn navbar__notif-btn--reject"
          disabled={loading}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onReject?.();
          }}
        >
          {loading ? "..." : "Reject"}
        </button>
      </div>
    );
  }

  if (normalizedStatus === "accepted") {
    return (
      <div
        className="navbar__notif-actions"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="navbar__notif-btn navbar__notif-btn--reject"
          disabled={loading}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onRevoke?.();
          }}
        >
          {loading ? "..." : "Révoquer l’accès"}
        </button>
      </div>
    );
  }

  const labels = {
    rejected: "Demande refusée",
    revoked: "Accès révoqué",
    resolved: "Accès inactif",
    expired: "Accès expiré",
  };
  const label = labels[normalizedStatus];
  return label ? <small className="navbar__notif-access-status">{label}</small> : null;
}
